export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDI0IDE0Ij4KICA8ZyBpZD0iSGFtYnVyZ2VyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj4KICAgIDxsaW5lIGlkPSJMaW5lXzIiIGRhdGEtbmFtZT0iTGluZSAyIiB4Mj0iMjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTIpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDNjNDYiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMSIgZGF0YS1uYW1lPSJMaW5lIDEiIHgyPSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAzYzQ2IiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./images/menu.svg
// module id = 14
// module chunks = 0